var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTailwindcss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 30,
    viewBox: "0 0 49 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 10C13.8833 3.33333 17.9667 0 24.5 0C34.3 0 35.525 7.5 40.425 8.75C43.6917 9.58333 46.55 8.33333 49 5C47.3667 11.6667 43.2833 15 36.75 15C26.95 15 25.725 7.5 20.825 6.25C17.5583 5.41667 14.7 6.66667 12.25 10ZM0 25C1.63333 18.3333 5.71667 15 12.25 15C22.05 15 23.275 22.5 28.175 23.75C31.4417 24.5833 34.3 23.3333 36.75 20C35.1167 26.6667 31.0333 30 24.5 30C14.7 30 13.475 22.5 8.575 21.25C5.30833 20.4167 2.45 21.6667 0 25Z",
    fill: "#44A8B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindcss);
export default __webpack_public_path__ + "static/media/tailwindcss.456abc7ff8d209e24fe0298d1c72eae2.svg";
export { ForwardRef as ReactComponent };